import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { EditFieldRowProps } from './EditFieldRow.props';

export const EditFieldRow: React.FC<EditFieldRowProps> = ({
  label,
  required = false,
  fullWidth = false,
  helper,
  error = false,
  htmlFor,
  children,
}) => {
  // Only render a semantic <label> when we have a control to associate with;
  // otherwise use a neutral <span> so we don't claim a label relationship that
  // doesn't exist (e.g. when the slot is a tag picker or a multi-input editor).
  const labelSx = {
    display: 'block',
    fontSize: '9px',
    fontWeight: 600,
    color: 'text.secondary',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.04em',
    lineHeight: 1.2,
    mb: 0.5,
  };
  const labelEl = htmlFor ? (
    <Typography component="label" htmlFor={htmlFor} sx={labelSx}>
      {label}
      {required ? (
        <Box component="span" sx={{ color: 'error.main', ml: 0.25 }} aria-hidden="true">
          *
        </Box>
      ) : null}
    </Typography>
  ) : (
    <Typography component="span" sx={labelSx}>
      {label}
      {required ? (
        <Box component="span" sx={{ color: 'error.main', ml: 0.25 }} aria-hidden="true">
          *
        </Box>
      ) : null}
    </Typography>
  );

  const helperEl = helper ? (
    <Typography
      sx={{
        mt: 0.5,
        fontSize: '11px',
        lineHeight: 1.3,
        color: error ? 'error.main' : 'text.secondary',
      }}
    >
      {helper}
    </Typography>
  ) : null;

  return (
    <Box sx={{ ...(fullWidth && { gridColumn: '1 / -1' }) }}>
      {labelEl}
      {children}
      {helperEl}
    </Box>
  );
};
